import React, { FC } from "react";
import { observer } from "mobx-react-lite";
import { makeStyles, Box } from "@material-ui/core";
import { Text } from "../components/Text";
import { Link } from "react-router-dom";
import { useIdentityContext } from "react-netlify-identity";
import colors from "../constants/colors";
import { store } from "../store";

const Account: FC = observer(() => {
  const classes = styles();
  const { logoutUser } = useIdentityContext();
  const { resetDesigns } = store;

  return (
    <Box className={classes.container}>
      <Text size="large" gutterBottom bold>
        Account Settings
      </Text>
      <Link to="/mydesigns" className={classes.setting}>
        My Designs
      </Link>
      <Link to="/reset" className={classes.setting}>
        Change Password
      </Link>
      <Link
        to="/"
        className={classes.setting}
        onClick={() => {
          logoutUser();
          resetDesigns();
        }}
      >
        Log Out
      </Link>
    </Box>
  );
});

const styles = makeStyles((theme) => ({
  container: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    position: "relative",
    padding: "50px 0px 100px 0px",
    margin: "50px auto",
    maxWidth: 900,
  },
  setting: {
    textDecoration: "none",
    marginTop: 20,
    cursor: "pointer",
    color: colors.secondary,
    "&:hover": {
      color: colors.primary,
    },
  },
}));

export default Account;
